import { isNil } from 'lodash-es';

function traverse(options: any[]) {
  // 先转成扁平 map，便于快速查找
  const nodeMap = new Map<number | string, any>();
  const parentMap = new Map<number | string, number | string>(); // id → parentId

  function fn(nodes: any[], parentId: number | string | null = null) {
    for (const node of nodes) {
      const id = node.value ?? node.id; // 兼容 value/id 字段 —— 你数据中 root 用 value，child 用 id，但 child 也有 value
      nodeMap.set(id, node);
      if (parentId !== null) {
        parentMap.set(id, parentId);
      }
      if (node.children && node.children.length) {
        fn(node.children, id);
      }
    }
  }

  fn(options);
  return { nodeMap, parentMap };
}

// 后端返回设备id, 前端是级联器, 需要寻找其父级,返回一个数组
export function buildCascaderPathById(options: any[], targetId: number | string): (number | string)[] | undefined {
  const { nodeMap, parentMap } = traverse(options);

  // 从 targetId 向上回溯路径
  const path: (number | string)[] = [];
  let currentId: number | string | undefined = targetId;

  // 先加入自身
  if (!nodeMap.has(targetId)) return undefined; // 找不到
  path.push(targetId);

  // 向上找父级，直到无 parentId（即根节点）
  while (parentMap.has(currentId)) {
    const parentId = parentMap.get(currentId);
    if (parentId === undefined) break;
    path.unshift(parentId); // 插入到开头
    currentId = parentId;
  }

  return path;
}

export const getCascaderLabelById = (options: any[], targetId: number | string): string | undefined => {
  if (!options || !options.length) return undefined;

  const { nodeMap, parentMap } = traverse(options);

  // 从 targetId 向上回溯路径
  let currentId: number | string | undefined = targetId;
  const labels: string[] = [];

  // 先加入自身
  const node = nodeMap.get(targetId);
  if (!node || isNil(node.label)) return undefined;
  labels.push(node.label);

  while (parentMap.has(currentId)) {
    const parentId = parentMap.get(currentId);
    if (parentId === undefined) break;
    const node = nodeMap.get(parentId);
    if (node && !isNil(node.label)) {
      labels.unshift(node.label);
    }
    currentId = parentId;
  }
  return labels.join('/');
};
